import { render, staticRenderFns } from "./sihuang-contract-template.html?vue&type=template&id=83dd090a&scoped=true&external"
import script from "./sihuang-contract-template.js?vue&type=script&lang=js&external"
export * from "./sihuang-contract-template.js?vue&type=script&lang=js&external"
import style0 from "./sihuang-contract-template.scss?vue&type=style&index=0&id=83dd090a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dd090a",
  null
  
)

export default component.exports